<template>
  <section class="content">
    <div class="modal show" tabindex="-1" role="dialog" ref="formComment" data-backdrop="static">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">{{ ticketTitle }}</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body pb-0">

            <form role="form" @submit.prevent="submitForm">
              <div>
                <h3>KODE #{{ code }}</h3>
                <p>Catatan : {{ catatan }}</p>
              </div>
              <div class="alert alert-success" v-if="ticketStatus == 2">{{ updatedBy }} on {{ updatedOn }}</div>
              <div v-if="ticketStatus != 2">
                <div class="row">
                  <div class="col-md-12 form-group">
                    <label class="control-label">Pesan</label>
                    <textarea class="form-control" v-model="form.message" required="required"></textarea>
                    <small class="form-text text-muted">Maksimal 400 karakter</small>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-6">
                    <input type="file" accept="image/*" name="userfile[]" id="userfile" ref="userfile" multiple
                      style="display: none" @change="uploadFiles" />

                    <button type="button" @click="showUpload" class="btn-xs btn btn-secondary" :disabled="loading">
                      <i class="fa fa-paperclip"></i> Lampiran
                    </button>

                    <ul class="list-unstyled pt-2">
                      <li v-for="(file, index) in files" :key="index" class="mb-1">
                        <!-- Nama File -->
                        <small :class="file.status === false ? 'text-danger' : ''">
                          {{ file.name }}
                        </small>

                        <span class="ml-2">
                          <!-- 1. Spinner: Muncul jika status belum ada (masih proses upload) -->
                          <div class="spinner-border spinner-border-sm text-primary" role="status" v-if="file.status === undefined">
                            <span class="sr-only">Loading...</span>
                          </div>

                          <!-- 2. Tombol Hapus: Muncul jika upload BERHASIL (status true) -->
                          <button v-if="file.status === true" @click="removeFile(file.code, index)" type="button"
                            class="btn btn-xs btn-outline-danger">
                            <i class="fa fa-times"></i>
                          </button>

                          <!-- 3. Icon Error: Muncul jika upload GAGAL (status false) -->
                          <span v-if="file.status === false" class="badge badge-danger" :title="file.desc">
                            <i class="fa fa-exclamation-circle"></i> {{ file.desc }}
                          </span>
                        </span>
                      </li>
                    </ul>
                  </div>
                  <div class="col-md-6 text-right">
                    <button type="button" class="btn btn-secondary mr-2" v-if="false">
                      Pending
                    </button>
                    <button type="submit" class="btn btn-primary" :disabled="loading">
                      <span class="spinner-border spinner-border-sm" role="status" v-if="loading">
                        <span class="sr-only">Loading...</span>
                      </span>
                      Kirim
                    </button>
                  </div>
                </div>
              </div>
              <div class="alert"
                v-bind:class="{ 'alert-claim-2 text-dark': returnClaim == '2', 'alert-claim-3': returnClaim == '3' }"
                v-if="returnClaim">
                Note :
                <span v-if="returnClaim == 1">Paket Diclaim</span>
                <span v-else-if="returnClaim == 2">Claim disetujui</span>
                <span v-else-if="returnClaim == 3">Claim ditolak</span>
                {{ return_claim_done }}
              </div>
            </form>
          </div>
          <div class="direct-chat-messages" style="height: auto">
            <!-- Message. Default to the left -->
            <div class="direct-chat-msg" v-for="comment in comments">
              <div class="direct-chat-infos d-flex justify-content-between" :class="{ 'flex-row-reverse' : comment.claim }">
                <span class="direct-chat-name">{{
                    comment.who
                }}</span>
                <span class="direct-chat-timestamp">{{
                    comment.time
                }}</span>
              </div>

              <div v-if="comment">
                <!-- /.direct-chat-img -->
                <div :class="( comment.message.split(' ')[1] == 'DiBanding' || comment.message.split(' ')[1] == 'Pending' ? 'direct-chat-info' : comment.message.split(' ')[1] == 'DiTolak' ? 'direct-chat-red' : comment.message.split(' ')[1] == 'DiSetujui' ? 'direct-chat-teal' : comment.message.split(' ')[1] == 'reject' ? 'direct-chat-maroon' : comment.message.split(' ')[1] == 'approve' ? 'direct-chat-olive' : 'direct-chat-primary' )">
                  <div class="right">
                    <div class="direct-chat-text w-fit mx-0" :class="( comment.claim ? 'ml-auto' : 'd-none' )">
                      {{ comment.message }}
                    </div>
                  </div>
                  <div class="direct-chat-text w-fit mx-0" :class="( comment.claim ? 'd-none' : 'mr-auto' )">
                    {{ comment.message }}
                  </div>
                </div>
              </div>
              <ul style="padding-left: 0">
                <li v-for="file in comment.attachments" style="list-style: none;display: inline-block;margin-right: 5px;">
                  <a style="cursor: pointer" @click="openImg(file)"><i class="fa fa-paperclip"></i> {{ file.name }}</a>
                </li>
              </ul>
              <!-- /.direct-chat-text -->
            </div>
          </div>
        </div>
      </div>
    </div>
    <LightBox ref="lightbox" :media="media" :show-caption="true" :show-light-box="false" :showThumbs="false"
      :showFooterCount="false">
    </LightBox>
  </section>
</template>
<script>
import { authFetch, charsRemover } from "@/libs/hxcore";
import $ from "jquery";
import Swal from "sweetalert2";
import LightBox from "vue-image-lightbox";

import vSelect from "vue-select";
import maskedInput from "vue-masked-input";
import { CurrencyInput } from "vue-currency-input";
import "vue-select/dist/vue-select.css";
require("vue-image-lightbox/dist/vue-image-lightbox.min.css");
export default {
  name: "TicketComment",
  props: { show: Boolean, value: Object, orderId: String },
  data() {
    return {
      ticketTitle: "Lihat Ticket",
      errors: [],
      categories: [],
      priorityOpt: [],
      comments: [],
      method: "POST",
      selectedId: 0,
      defaultId: 1,
      addrOptions: [],
      addrJne: [],
      courierBranchOption: [],
      formTitle: "Buat Tiket",
      files: [],
      loaded: false,
      loading: false,
      code: "",
      catatan: "",
      ticketStatus: '',
      form: {
        //to create pickup address
        id: "",
        message: "",
        attachments: "",
        refcode: "",
      },
      imgshow: true,
      media: [
        {
          // For image
          thumb: "",
          src: "",
          caption: "",
        },
      ],
      returnClaim: "",
    };
  },
  components: {
    vSelect,
    maskedInput,
    LightBox,
  },
  created() { },
  methods: {
    openImg: function (file) {
      var attr = {
        thumb: file.link,
        src: file.link,
        caption: file.name,
      };
      this.media = [attr];
      this.$refs.lightbox.showImage(0);
      return false;
    },
    submitForm: function (ev) {
      this.loading = true;
      var items = [];
      var refcode = this.form.refcode;
      for (var i in this.files) {
        items.push(this.files[i].code);
      }
      this.form.attachments = items.join(",");
      var data = Object.keys(this.form)
        .map(
          (key) =>
            encodeURIComponent(key) + "=" + encodeURIComponent(this.form[key])
        )
        .join("&");
      authFetch("/ticket/comment", {
        method: "POST",
        body: data,
      })
        .then((res) => {
          if (res.status === 201) {
          } else if (res.status === 400) {
          }
          return res.json();
        })
        .then((js) => {
          this.loading = false;
          if (js.success) {
            this.form = { refcode };
            this.files = [];
            this.loadTicket(this.orderId);
            this.$root.$emit("reloadDashboardTicket");
            this.$root.$emit("reloadMenuTicket");
          }
        });
    },
    showUpload: function (ev) {
      //$(this.$refs.formUpload).modal("show");
      $(this.$refs.userfile).click();
    },
    uploadFiles: function (event) {
      this.loading = true;
      const input = event.target;
      this.files = input.files;
      
      const formData = new FormData();
      // Gunakan loop standar untuk menghindari iteration pada properti non-file
      for (let i = 0; i < this.files.length; i++) {
        formData.append("file[]", this.files[i]);
      }
      formData.append("refcode", this.orderId);

      authFetch("/ticket/upload", {
        method: "POST",
        body: formData,
        headers: {
          "Content-Type": null, // Biarkan browser menentukan boundary multipart/form-data
        },
      })
        .then((res) => res.json())
        .then((json) => {
          this.loading = false;
          
          // 1. Cek apakah ada file yang error
          const failedFiles = json.filter(file => file.status === false);
          const successfulFiles = json.filter(file => file.status === true);

          if (failedFiles.length > 0) {
            // Susun pesan error untuk file yang gagal
            let errorMsg = failedFiles.map(f => `<li><b>${f.name}</b>: ${f.desc}</li>`).join('');
            
            this.customSwal.fire({
              icon: 'error',
              title: 'Beberapa file gagal diupload',
              html: `<div class="text-left"><ul style="font-size: 0.9rem;">${errorMsg}</ul></div>`,
              confirmButtonText: 'Tutup'
            });
          }

          // 2. Simpan hanya file yang sukses ke state atau tampilkan semua
          // Tergantung kebutuhanmu, biasanya kita hanya ingin menyimpan yang sukses
          this.files = json; 
          
          // Reset input file agar bisa upload ulang file yang sama jika perlu
          input.value = '';
        })
        .catch((err) => {
          this.loading = false;
          console.error("Upload error:", err);
        });
    },
    removeFile: function (code) {
      let newFiles = this.files.filter(function (arr, i) {
        return arr.code != code;
      });
      this.files = newFiles;
    },
    loadTicket: function (id) {
      authFetch("/ticket/order/" + id).then((res) => {
        res.json().then((json) => {
          if (json.success) {
            this.ticketTitle = json.data.title;
            this.comments = json.comments;
            this.form.id = json.data.id;
            this.code = json.data.no_resi;
            this.catatan = json.data.catatan;
            this.ticketStatus = json.data.status;
            this.updatedBy = json.data.updatedBy;
            this.updatedOn = json.data.updatedOn;
            this.returnClaim = json.data.return_claim;
            this.claim = json.comments.claim;
            this.return_claim_done = json.data.return_claim_done;
            //this.categories = json.data;
          }
        });
      });
    },
  },
  mounted() {
    // console.log("warehouse1", this.value);
    const e = this.$refs;
    // if (this.show === true) $(e.formSelectPickup).modal("show");
    // console.log(this.show);         
    $(e.formComment).on("show.bs.modal", (e) => {
      //if (!this.loaded) {
      this.loaded = true;
      this.loadTicket(this.orderId);
      //this.$root.$emit("reloadDashboardTicket");
      //}
    });

		this.customSwal = Swal.mixin({
			customClass: {
				content: 'p-0',
				title: 'h4 tex-dark',
				input: 'form-control',
				actions: 'd-flex justify-content-between flex-row-reverse',
				confirmButton: 'btn btn-primary col font-weight-bold',
				denyButton: 'btn btn-outline-primary col font-weight-bold',
				cancelButton: 'btn btn-primary w-75 font-weight-bold m-auto',
			},
			buttonsStyling: false
		});
  },
  watch: {
    show: function (old, val) {
      $(this.$refs.formComment).modal("show");
    },
    orderId: function (old, val) {
      this.form.refcode = this.orderId;
    },
    value: function (old, val) { },
    form: {
      handler(val) {
        this.form.message = charsRemover(val.message);
      },
      deep: true
    },
  },
};
</script>
<style scoped>
.alert-claim-2 {
  color: #ffffff;
  background: #66ff33;
  border-color: #60F030;
}

.alert-claim-3 {
  color: #ffffff;
  background: #ff582e;
  border-color: #F0542B;
}

.direct-chat-teal > .direct-chat-text {
  background: #00AB4F;
  border-color: #00AB4F;
  color: #ffffff;
}

.direct-chat-teal > .direct-chat-text::after, .direct-chat-teal > .direct-chat-text::before {
  border-right-color: #00AB4F;
}

.direct-chat-olive > .direct-chat-text {
  background: #007837;
  border-color: #007837;
  color: #ffffff;
}

.direct-chat-olive > .direct-chat-text::after, .direct-chat-olive > .direct-chat-text::before {
  border-right-color: #007837;
}

.direct-chat-red > .direct-chat-text {
  background: #D60F0F;
  border-color: #D60F0F;
  color: #ffffff;
}

.direct-chat-red > .direct-chat-text::after, .direct-chat-red > .direct-chat-text::before {
  border-right-color: #D60F0F;
}

.direct-chat-maroon > .direct-chat-text {
  background: #8E1F29;
  border-color: #8E1F29;
  color: #ffffff;
}

.direct-chat-maroon > .direct-chat-text::after, .direct-chat-maroon > .direct-chat-text::before {
  border-right-color: #8E1F29;
}
</style>